module.exports = "/_next/static/images/e21c96ffbcb7fd80ba6ee7ad42931366-man-looking-at-phone@md-1x.jpg";